import { Component } from '@angular/core';
import {
  Banner,
  Benefits,
  CardCarousel,
  EarnsSummary,
  MicroMoments,
  Offers,
  Onboarding,
  QuickLinks,
  SkyClubTracker,
  Snapshot,
  Tracker,
  Upgrades
} from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  RelatedLinks,
  Stipulation,
  Summary
} from '@com-delta-idp/mnx-skymiles-shared';
import { StateFacade } from '../../data-access/facades/state.facade';
import { TrackerFacade } from '../../data-access/facades/tracker.facade';

@Component({
  selector: 'idp-skymiles-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.sass']
})
export class OverviewComponent {
  emptyOnboarding: Onboarding = {} as Onboarding;
  emptyMicroMoments: MicroMoments = {} as MicroMoments;
  emptySummary: Summary = {} as Summary;
  emptyTracker: Tracker = {} as Tracker;
  emptyStatus: Summary = {} as Summary;
  emptyCards: CardCarousel = {} as CardCarousel;
  emptyEarnsSummary: EarnsSummary = {} as EarnsSummary;
  emptySkyClubTracker: SkyClubTracker = {} as SkyClubTracker;
  emptyQuickLinks: QuickLinks = {} as QuickLinks;
  emptyBenefits: Benefits = {} as Benefits;
  emptySnapshot: Snapshot = {} as Snapshot;
  emptyUpgrades: Upgrades = {} as Upgrades;
  emptyBanner: Banner = {} as Banner;
  emptyOffers: Offers = {} as Offers;
  emptyRelatedLinks: RelatedLinks = {} as RelatedLinks;
  emptyStipulation: Stipulation = {} as Stipulation;

  constructor(public overview: StateFacade, public tracker: TrackerFacade) {
    overview.init();
  }

  close() {
    localStorage.setItem('welcomeTourModal', JSON.stringify(false));
  }

  redirect(url: string, type: string) {
    window.open(url, type === 'link' ? '_blank' : '_self');
  }
}
